import VMenu from './VMenu';

VMenu.install = function install(Vue) {
  Vue.component(VMenu.name, VMenu);
};

export default VMenu;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VMenu/index.js
// module id = DBae
// module chunks = 0